import { rpc } from './client.js';

export const pullRoster = (token, since = null) =>
  rpc('sps_roster', { p_token: token, p_since: since });
